import { PAGES } from '@/constants/pages';

export const STORAGE_TABS = {
  SIGN_CONTRACT: 'sign',
  MY_CELLAR: 'mycellar',
  HISTORY: 'history',
  WINEBOX: 'winebox',
  // SUBSCRIPTION: 'subscription'
};

export const STORAGE_SUBMENU_LINKS = [
  {
    title: 'menu.dashboard',
    url: PAGES.CELLAR
  },
  {
    title: 'menu.myCellar',
    url: `${PAGES.CELLAR}/${STORAGE_TABS.MY_CELLAR}`
  },
  {
    title: 'menu.history',
    url: `${PAGES.CELLAR}/${STORAGE_TABS.HISTORY}`
  },
  {
    title: 'menu.wineBox',
    url: `${PAGES.CELLAR}/${STORAGE_TABS.WINEBOX}`
  },
  // {
  //   title: 'menu.subscription',
  //   url: `${PAGES.CELLAR}/${STORAGE_TABS.SUBSCRIPTION}`
  // }
];

export const STORAGE_STATUS = {
  IN: 'IN',
  OUT: 'OUT'
};

export const CHART_COLORS = {
  1: ['#8C0303'],
  2: ['#8C0303', '#F2790F'],
  3: ['#8C0303', '#71102F', '#BF4904'],
  4: ['#8C0303', '#71102F', '#BF4904', '#DC776C'],
  5: ['#8C0303', '#71102F', '#BF4904', '#DC776C', '#F22929'],
  6: ['#8C0303', '#71102F', '#BF4904', '#DC776C', '#F22929', '#F2790F'],
  7: ['#8C0303', '#71102F', '#BF4904', '#DC776C', '#F22929', '#F2790F', '#F2EDA7'],
  8: ['#8C0303', '#71102F', '#BF4904', '#DC776C', '#F22929', '#F2790F', '#F2EDA7', '#FCBFC0'],
  9: ['#8C0303', '#71102F', '#BF4904', '#DC776C', '#F22929', '#F2790F', '#F2EDA7', '#FFEBC9', '#FCBFC0'],
  10: ['#8C0303', '#71102F', '#BF4904', '#DC776C', '#F22929', '#F2790F', '#F2EDA7', '#FFEBC9', '#FCBFC0', '#260F0A']
};
